export const ServerConfig = {
	host: process.env.VUE_APP_API_HOST || "",
	socket: process.env.VUE_APP_API_SOCKET || "",
	auth: process.env.VUE_APP_API_AUTH || "",
	authSocket: process.env.VUE_APP_API_AUTH_SOCKET || "",
	baseHostname: process.env.VUE_APP_BASE_HOSTNAME || ""
};
